import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import App from './app/App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {AppThemeProvider} from './providers/AppThemeProvider';
import {AuthProvider} from './shared/auth/AuthContext';
import {PortalAccessProvider} from './shared/auth/PortalAccessContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <PortalAccessProvider>
                    <AppThemeProvider
                        primaryColor="#2563eb"
                        accentColor="#0891b2"
                        companyName="BusiFarm"
                    >
                        <App />
                    </AppThemeProvider>
                </PortalAccessProvider>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();
